import type { FilterSeparator } from '@sorare/core/src/lib/filters';

export const filterSeparator: FilterSeparator = { type: 'separator' };
export {
  RefineActiveNationalTeam,
  RefineActiveLeague,
  RefineCardEdition,
  RefinePlayer,
  RefineSeason,
  RefineSingleYearSeason,
  RefinePlayingStatus,
  RefineNationality,
  RefineBirthplace,
} from './RefineList/index.tsx';
export { RefineCardPlayerAge } from './RefineAge/index.tsx';
export { RefineCardLevel } from './RangeSlider/index.tsx';
export {
  RefineAverageScore,
  RefineBackendAverageScore,
} from './RefineAverageScore/index.tsx';
export { RefineAppearances } from './RefineAppearances/index.tsx';
export { RefineSerialNumber } from './RefineSerialNumber/index.tsx';
export {
  widget as RefineCompetitionEligibility,
  BackendRefineCompetitionEligibility,
} from './RefineCompetitionEligibility/index.tsx';

export { widget as NotInLineupFilter } from './NotInLineupFilter/index.tsx';
export { widget as CollectibleFilter } from './CollectibleFilter/index.tsx';
export {
  GameweekFilter,
  DailyFilter,
  BackendGameweekFilter,
} from './FixtureFilter/index.tsx';
export { widget as RefineOnSale } from './RefineOnSale/index.tsx';
export { widget as RefineCreditEligible } from './RefineCreditEligible/index.tsx';
export { AdvancedCardSearch } from './AdvancedCardSearch/index.tsx';
export {
  widget as PromotionalEventFilter,
  PromotionalEventFilterForInstantBuy,
} from './PromotionalEventFilter/index.tsx';
export { widget as RefineInSeason } from './RefineInSeason/index.tsx';
export {
  AcceptedCurrencyGroup,
  CollectibleGroup,
  PriceGroup,
  RarityGroup,
  SaleGroup,
} from './refineGroups.tsx';
export {
  RefinePosition,
  RefineBackendPosition,
} from './RefinePosition/index.tsx';
export { widget as BidToEarnFilter } from './BidToEarnFilter/index.tsx';
export { RevealableCardCampaignMenu } from './RevealableCardCampaignMenu/index.tsx';
